import { render, staticRenderFns } from "./GantiPassword.vue?vue&type=template&id=b32c745c"
import script from "./GantiPassword.vue?vue&type=script&lang=js"
export * from "./GantiPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports